import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { DatepickerHelper } from '@shared/validators/date-picker-form-validators';
import { Company } from '@models/companies/company';
import { Document } from "@models/documents/document";
import { IPDFSection } from '../ui-models/pdf-section.interface';
import { ChangeDictionaryHelper } from "../ui-models/change-dictionary-helper.model";
import { Entity } from "@models/companies/entity";
import { Guid } from "@shared/utils/guid.helper";

export abstract class EntityChangeData{
    $type: string;
    changeId: string;
    changeName: string;
    changeDate: Date;
    changeType: string;
    description: string;

    static readonly $type: string;

    constructor(data: Partial<EntityChangeData> = {}) {
        this.$type = (this.constructor as typeof EntityChangeData).$type;
        this.changeDate = DatepickerHelper.toDate(data.changeDate);
        // TODO: REPLACE WITH BE LOGIC AND ALLOW NULL OR EMPTY GUID
        this.changeId = data.changeId || Guid.generate();
        this.changeName = data.changeName ?? '';
        this.changeType = data.changeType ?? '';
        this.description = data.description ?? '';
    }

    abstract toDictionary(entity: Entity): { key: string, value: string }[];

    abstract fillModal(modalRef: NgbModalRef, document: Document, actualCompany: Company): NgbModalRef;

    abstract fillModalWithCompany(modalRef: NgbModalRef, company: Company, isEdit: boolean): NgbModalRef;

    buildPreviewType(): string { return this.changeType; }

    prepareToRequest(): EntityChangeData {
        return { ...this, changeDate: DatepickerHelper.buildDateString(this.changeDate) };
    }

    prepareToPdf(entity: Entity): IPDFSection[] {
      return new ChangeDictionaryHelper().addSection(this.description, this.toDictionary(entity)).sections;
    }
}
